import script from "./adminSidebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./adminSidebar.vue?vue&type=script&setup=true&lang=ts"

import "./adminSidebar.vue?vue&type=style&index=0&id=66022d9c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66022d9c"]])

export default __exports__